<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import '@jobinsjp/vue3-datatable/dist/style.css';
import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
import moment from 'moment';
import Swal from 'sweetalert2';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const loading = computed(() => store.state.globals.loading);
const roles = computed(() => store.state.role.roles);
const pagination = computed(() => store.state.role.pagination);
const title = ref("Roles and Permissions");
const items = ref([
  {
      text: "Home",
      href: "/"
    },
      {
      text: "User Management",
    },
    {
      text: "Roles and Permissions List",
      active: true,
    }
])

const query = ref({
    search: ''        
})

const getAllRoles = async (dt) => {
  await store.dispatch('role/getRoles', {
    page: dt.page,
    pageSize: dt.per_page,
    sortColumn: 'updated_at',
    search: dt.search,
    orderBy: 'desc'
  });
}

const deleteRole = (id, name) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.value) {
          store.dispatch('role/deleteRole', { id, name });
        }
      });
  }

const formattedDate = (date) => {
  return moment(date).format('YYYY-MM-DD h:mm A')
}
</script>

<template>
  <Layout>
    
      <PageHeader :title="title" :items="items" />
      <div class="d-flex mb-4 justify-content-between">
        <div>
          <h1 class="fs-4 text">Roles and Permissions List</h1>
          <small>Lists of all roles and permissions</small>
        </div>
        <div>
          <router-link
              to="/user-management/roles/create"
              class="btn btn-primary right"
            >
              <i class="ri-add-fill label-icon align-middle fs-16 me-2"></i>
              New Role
          </router-link>
        </div>
      </div>

      <b-overlay :show="loading">
          <div class="col lg-12">
              <data-table :rows="roles"
                  :pagination="pagination"
                  striped
                  :loading="loading"
                  :query="query"
                  filter
                  hoverable
                  sortable
                  @loadData="getAllRoles"
              >
                <template #thead>
                    <table-head>Role Key</table-head>
                    <table-head>Role Name</table-head>
                    <table-head>User Count</table-head>
                    <table-head>Date Modified</table-head>
                    <table-head>Action</table-head>
                </template>

                <template #tbody="{row}">
                    <table-body v-text="row.slug"/>
                    <table-body v-text="row.name"/>
                    <table-body v-text="row.user_count"/>
                    <table-body>
                      {{ formattedDate(row.updated_at) }}
                    </table-body>
                    <table-body>
                      <router-link
                          :to="`/user-management/roles/${row.id}/settings`"
                          class="btn btn-info mr-1"
                          title="Settings"
                        >
                        <i class="ri-settings-3-fill label-icon align-middle"></i>
                      </router-link>
                      <button
                          @click="deleteRole(row.id, row.name)"
                          class="btn btn-danger"
                          title="Delete"
                      >
                        <i class="mdi mdi-delete"></i>
                      </button>
                    </table-body>
                </template>

                <template #empty>
                  <TableBodyCell colspan="10">
                      No user found.
                  </TableBodyCell>
              </template>
            </data-table>
          </div>
      </b-overlay>
  </Layout>
</template>